import { render, staticRenderFns } from "./EmployeeCompanyItem.vue?vue&type=template&id=0b91f09c&scoped=true&lang=pug"
import script from "./EmployeeCompanyItem.vue?vue&type=script&lang=ts"
export * from "./EmployeeCompanyItem.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeCompanyItem.vue?vue&type=style&index=0&id=0b91f09c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91f09c",
  null
  
)

export default component.exports